window.SDT = window.SDT || {};

$(function() {

    SDT.smartdate = function(node){
        $this = $( node );
        utc = $this.text();
        d = new Date(utc);
        formatted = $.format.date(d, "M/dd/yyyy");
        formattedfull = $.format.date(d, "M/dd/yyyy hh:mm a");
        $this.text(formatted);
        $this.attr('title',formattedfull + " - " + getTimeDiffAndPrettyText(d).friendlyNiceText + " - UTC:" + utc);
    }

    SDT.smarttime = function(node){
        $this = $( node );
        utc = $this.data("utc");
        d = new Date(utc);
        formatted = $.format.date(d, "hh:mm a");
        formattedfull = $.format.date(d, "M/dd/yyyy hh:mm a");
        $this.text(formatted);
        $this.attr('title',formattedfull + " - " + getTimeDiffAndPrettyText(d).friendlyNiceText + " - UTC:" + utc);
    }

    SDT.smartdatetime = function(node){
        $this = $( node );
        utc = $this.text();
        //console.log(utc);
        d = new Date(utc);
        formatted = $.format.date(d, "M/dd/yyyy, hh:mm a");
        $this.text(formatted);
        $this.attr('title',getTimeDiffAndPrettyText(d).friendlyNiceText + " - UTC:" + utc);
    }

    SDT.smartdatetimetz = function(node){
        $this = $( node );
        utc = $this.text();
        //console.log(utc);
        d = new Date(utc);
        formatted = $.format.date(d, "M/dd/yyyy, hh:mm a");
        $this.text(formatted + " (" + SDT.getBrowserTimeZone() + ")");
        $this.attr('title',getTimeDiffAndPrettyText(d).friendlyNiceText + " - UTC:" + utc);
    }

    SDT.reloadSmartTimes = function(){
        $(".smart-date").each(function() {
            SDT.smartdate(this);
        });
        $(".smart-time").each(function() {
            SDT.smarttime(this);
        });
        $(".smart-datetime").each(function() {
            SDT.smartdatetime(this);
        });
        $(".smart-datetimetz").each(function() {
            SDT.smartdatetimetz(this);
        });
    }

    SDT.getBrowserTimeZone = function(){

        var result = "";
        try{
            // Chrome, Firefox
            result = /.*\s(.+)/.exec((new Date()).toLocaleDateString(navigator.language, { timeZoneName:'short' }))[1];
        }catch(e){
            // IE, some loss in accuracy due to guessing at the abbreviation
            // Note: This regex adds a grouping around the open paren as a
            //       workaround for an IE regex parser bug
            result = (new Date()).toTimeString().match(new RegExp("[A-Z](?!.*[\(])","g")).join('');
        }

        return result

    }

    function getTimeDiffAndPrettyText(oDatePublished) {

        var oResult = {};

        var oToday = new Date();

        var nDiff = oToday.getTime() - oDatePublished.getTime();
        var future = false;
        if(oToday.getTime() < oDatePublished.getTime()){
            nDiff = oDatePublished.getTime() - oToday.getTime();
            future = true;
        }

        // Get diff in days
        oResult.days = Math.floor(nDiff / 1000 / 60 / 60 / 24);
        nDiff -= oResult.days * 1000 * 60 * 60 * 24;

        // Get diff in hours
        oResult.hours = Math.floor(nDiff / 1000 / 60 / 60);
        nDiff -= oResult.hours * 1000 * 60 * 60;

        // Get diff in minutes
        oResult.minutes = Math.floor(nDiff / 1000 / 60);
        nDiff -= oResult.minutes * 1000 * 60;

        // Get diff in seconds
        oResult.seconds = Math.floor(nDiff / 1000);

        // Render the diffs into friendly duration string

        // Days
        var sDays = '00';
        if (oResult.days > 0) {
            sDays = String(oResult.days);
        }
        if (sDays.length === 1) {
            sDays = '0' + sDays;
        }

        // Format Hours
        var sHour = '00';
        if (oResult.hours > 0) {
            sHour = String(oResult.hours);
        }
        if (sHour.length === 1) {
            sHour = '0' + sHour;
        }

        //  Format Minutes
        var sMins = '00';
        if (oResult.minutes > 0) {
            sMins = String(oResult.minutes);
        }
        if (sMins.length === 1) {
            sMins = '0' + sMins;
        }

        //  Format Seconds
        var sSecs = '00';
        if (oResult.seconds > 0) {
            sSecs = String(oResult.seconds);
        }
        if (sSecs.length === 1) {
            sSecs = '0' + sSecs;
        }

        //  Set Duration
        var sDuration = sDays + ':' + sHour + ':' + sMins + ':' + sSecs;
        oResult.duration = sDuration;

        var fstr = " ago"
        if(future){
            fstr = " in the future"
        }

        // Set friendly text for printing
        if(oResult.days === 0) {

            if(oResult.hours === 0) {

                if(oResult.minutes === 0) {
                    var sSecHolder = oResult.seconds > 1 ? 'Seconds' : 'Second';
                    oResult.friendlyNiceText = oResult.seconds + ' ' + sSecHolder + fstr;
                } else {
                    var sMinutesHolder = oResult.minutes > 1 ? 'Minutes' : 'Minute';
                    oResult.friendlyNiceText = oResult.minutes + ' ' + sMinutesHolder + fstr;
                }

            } else {
                var sHourHolder = oResult.hours > 1 ? 'Hours' : 'Hour';
                oResult.friendlyNiceText = oResult.hours + ' ' + sHourHolder + fstr;
            }
        } else {
            var sDayHolder = oResult.days > 1 ? 'Days' : 'Day';
            oResult.friendlyNiceText = oResult.days + ' ' + sDayHolder + fstr;
        }

      return oResult;
    }

    SDT.reloadSmartTimes();

});


